/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Override of SideDrawer.open: when no explicit focus target is given, send
   * focus to the cart title (#CartDrawerModal-Title, tabindex="-1") instead of
   * to the dialog container itself. This stops VoiceOver from announcing
   * "and N more items" when the dialog is large (with cross-sells, footer,
   * subtotal, etc.) — focusing the title makes it read just "Carrito".
   *
   * Empty-cart fallback: when the cart is empty, the main content (and its
   * title) is hidden via .cart-drawer__content--hidden, so .focus() on the
   * title is a no-op and focus stays outside the drawer — which means the
   * Escape keyup listener (bound to the drawer element) never fires. Detect
   * the hidden title via offsetParent and fall back to the visible empty-state
   * container so focus lands inside the drawer and Escape works.
   */
  open(opener, elementToFocus, callback) {
    // If the drawer is already open (e.g. user adds another item from the
    // cross-sell carousel inside the open drawer), do NOT re-run super.open():
    // it would re-trap focus on the title, which makes VoiceOver re-read
    // "Carrito" and interrupt the live-region announcement. Just no-op so the
    // pending live-region message can be heard cleanly.
    if (this.hasAttribute('open')) {
      if (typeof callback === 'function') callback();
      return;
    }

    let target = elementToFocus;
    if (!target) {
      // Detect empty cart by class state, not by offsetParent/visibility:
      // the drawer is still visibility:hidden when open() is invoked (super
      // sets [open] right after this), so live visibility checks lie.
      const content = this.querySelector('.cart-drawer__content');
      const isEmpty = content && content.classList.contains('cart-drawer__content--hidden');
      target = isEmpty
        ? this.querySelector('.cart-drawer__empty-content')
        : this.querySelector('#CartDrawerModal-Title');
      if (!target) target = this;
    }
    super.open(opener, target, callback);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
